export default __webpack_public_path__ + "static/media/chapman_thumb500px.b723c3a4.jpg";